// src/components/StartScreen.jsx
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const StartScreen = ({ onStart }) => {
  const [animationState, setAnimationState] = useState("initialCircle");

  // Dimensions estimades del botó quan té text.
  // Ajusta-les segons el teu text i padding!
  const finalButtonWidth = '180px'; // Exemple
  const finalButtonHeight = '54px'; // Exemple (padding 15px dalt/baix + font-size ~24px)

  useEffect(() => {
    // Fase 1: El cercle apareix
    const phase1Timer = setTimeout(() => {
      setAnimationState("visibleCircle");
    }, 50);

    // Fase 2: El cercle es prepara per transformar-se i el text apareix
    const phase2Timer = setTimeout(() => {
      setAnimationState("textVisible");
    }, 400); // Després que visibleCircle hagi tingut temps d'animar-se (0.3s)

    return () => {
      clearTimeout(phase1Timer);
      clearTimeout(phase2Timer);
    };
  }, []);

  const buttonVariants = {
    initialCircle: {
      width: '70px',
      height: '70px',
      borderRadius: '50%',
      padding: '0px', // Sense padding intern inicialment
      opacity: 0,
      scale: 0.8,
      display: 'flex', // Important per a align/justify
      alignItems: 'center',
      justifyContent: 'center',
    },
    visibleCircle: {
      width: '70px',
      height: '70px',
      borderRadius: '50%',
      padding: '0px',
      opacity: 1,
      scale: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: { duration: 0.3, ease: 'easeOut' },
    },
    textVisible: {
      width: finalButtonWidth,   // Anima a una amplada fixa
      height: finalButtonHeight, // Anima a una alçada fixa
      borderRadius: '35px',      // Transforma a píndola
      padding: '15px 30px',      // Aplica el padding final
      opacity: 1,
      scale: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: { 
        duration: 0.4, 
        ease: 'easeInOut', // Un easing una mica més suau per a la transformació
        // Podries animar width/height/borderRadius amb diferents delays/durations si cal
      },
    },
  };

  const textSpanVariants = {
    hidden: { opacity: 0, y: 5 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.3, ease: 'easeOut', delay: 0.25 } // Delay per aparèixer quan el botó ja s'està transformant
    },
  };

  return (
    <div className="screen-container">
      <motion.button
        className="screen-button" // screen-button ja té display: inline-flex
        onClick={onStart}
        variants={buttonVariants}
        initial="initialCircle"
        animate={animationState}
        whileHover={animationState === "textVisible" ? { scale: 1.05, transition: { type: 'spring', stiffness: 400, damping: 10 } } : {}}
        whileTap={animationState === "textVisible" ? { scale: 0.95 } : {}}
      >
        <motion.span
          className="light-text"
          variants={textSpanVariants}
          initial="hidden"
          animate={animationState === "textVisible" ? "visible" : "hidden"}
        >
          let's
        </motion.span>
        <motion.span
          className="semibold-text margin-inside-buttons"
          variants={textSpanVariants}
          initial="hidden"
          animate={animationState === "textVisible" ? "visible" : "hidden"}
        >
          fly
        </motion.span>
      </motion.button>
    </div>
  );
};

export default StartScreen;